import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AmpluggedPlayer from '@/components/AmpluggedPlayer/AmpluggedPlayer.vue'

import SignIn from '@/components/SignIn.vue'
import store from '@/store/index.js'


import { AmplifyEventBus } from 'aws-amplify-vue'
import * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

Vue.use(VueRouter)
Vue.use(AmplifyPlugin, AmplifyModules)


let user;

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      store.commit('setUser', data)
    // console.log(`ユーザーのデータ: ${JSON.stringify(data)}`);
      return data;
    }
  }).catch(() => {
    store.commit('setUser', null)
    return null
  })
}


// AmplifyEventBus.$on('authState', async (state) => {
//   if (state === 'signedOut'){
//     user = null
//     store.commit('setUser', null)
//     router.push({path: '/signin'}, () => {})
//   } else if (state === 'signedIn') {
//     user = await getUser();
//     router.push({path: '/'})
//   }
// })

AmplifyEventBus.$on('authState', async info => {
  if (info === 'signedIn') {
    // this.$router.push({ name: 'Home' });
    // if (parantExistanceFlag) {
      // window.opener.location.reload();
      console.log("ログインイベント");
      window.close();
    // }
  }
  else {
    this.signedIn = false;
  }
});
      
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/:id/*/',//id file名
    name: 'AmpluggedPlayer',
    component: AmpluggedPlayer
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignIn
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})



router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    user = await getUser()
    if (!user) {
      return next({
        path: '/signin'
      })
    }
    return next()
  }
  return next()
})

export default router
